import { t as trapFocus, r as removeTrapFocus } from './index-BIftRuJC.js';

/**
 * @class OptionSelector
 * @extends HTMLElement
 */
class OptionSelector extends HTMLElement {
  /** @type {string} */
  id = this.getAttribute('id');

  /** @type {HTMLElement} */
  button = this.querySelector('[data-option-selector="button"]');

  /** @type {HTMLElement} */
  offcanvas = this.querySelector('[data-option-selector="offcanvas"]');

  /** @type {HTMLElement} */
  selectedValue = this.querySelector('[data-option-selector="selected-value"]');

  /** @type {HTMLElement[]} */
  closes = this.querySelectorAll('[data-option-selector="close"]');

  connectedCallback() {
    this.button?.addEventListener('click', () => {
      this.openPanel();
    });
    this.closes?.forEach((close) => {
      close?.addEventListener('click', () => {
        this.closePanel();
      });
    });
    this.querySelectorAll('input[type="radio"]').forEach((radio) => {
      radio.addEventListener('click', () => {
        this.selectedValue.textContent = radio?.value;
        const triggerOptionSelect = document.querySelector(
          `trigger-option-select[handle="${this.id}"] span`
        );
        triggerOptionSelect ? (triggerOptionSelect.textContent = radio?.value) : null;
        this.closePanel();
      });
    });
  }

  openPanel() {
    this.classList.add('is-open');
    this.button?.setAttribute('aria-expanded', 'true');
    trapFocus({ container: this.offcanvas });
  }

  closePanel() {
    this.classList.remove('is-open');
    this.button?.setAttribute('aria-expanded', 'false');
    removeTrapFocus();
  }
}

customElements.define('option-selector', OptionSelector);

class TriggerOptionSelect extends HTMLElement {
  handle = this.getAttribute('handle');

  connectedCallback() {
    this.addEventListener('click', () => {
      // Try to find option-selector with matching ID (for color panels)
      const optionSelector = document.querySelector(`option-selector#${this.handle}`);
      if (optionSelector) {
        optionSelector.openPanel();
        return;
      }

      // Extract option name from handle (e.g., "template--123__main-size" -> "size")
      const optionName = this.handle.split('-').pop();
      // Scroll to fieldset with matching option name (for size, etc.)
      const fieldset = document.querySelector(`[data-option-name="${optionName}"]`);
      if (fieldset) {
        fieldset.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  }
}

customElements.define('trigger-option-select', TriggerOptionSelect);
